import styled from "styled-components";

export const StyledNavbarContainerDiv = styled.div`
  margin: 0 120px;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth;

  /* Hide scrollbars */
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }
`;
export const StyledNavbarItemSpan = styled.span`
  display: flex;
  padding: 10px 16px;
  align-items: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  color: var(--character-primary-85, rgba(0, 0, 0, 0.85));
  flex-shrink: 0;

  span {
    padding: 12px 0;
    cursor: pointer;

    &:hover {
      border-bottom: 2px solid #1249bf;
      color: var(--BLUE, #2060ea);
    }
  }

  &.active span {
    color: var(--BLUE, #2060ea);
    border-bottom: 2px solid #1249bf;
  }
`;
